export default {
  requests(state, _, _2, rootGetters) {
    const skipperId = rootGetters.userId;

    var returnVal = state.requests.filter(req => {
      return req.skipperId === skipperId;
    });

    return returnVal;
  },
  hasRequests(_, getters) {
    if (getters.requests && getters.requests.length > 0) {
      return true;
    }
  }
};
